import {PromoError} from './types'

export const PROMO_CODE_PATTERN = /^[A-Z0-9]{4,20}$/
export const PROMO_CODE_MAX_LENGTH = 20

export const normalizePromoCode = (value: string) => value.trim().toUpperCase().replace(/\s+/g, '')

export const isValidPromoCode = (value: string) => PROMO_CODE_PATTERN.test(value)

type ErrorBody = {errors?: {code?: string; message?: string; meta?: PromoError['meta']}[]}

// Reads a §2 rejection (422 or 409 with `errors[0].code = PROMO_*`) out of an axios error.
export const getPromoErrorFromResponse = (error: unknown): PromoError | null => {
  const data = (error as {response?: {data?: ErrorBody}} | null)?.response?.data
  const first = data?.errors?.[0]
  if (first?.code && first.code.startsWith('PROMO_')) {
    return {code: first.code, message: first.message, meta: first.meta}
  }
  return null
}

/** A refusal from POST /promo-codes/validate, whose `message` is the server's friendly sentence. */
export const getValidateErrorFromResponse = (error: unknown): PromoError | null => {
  const promoError = getPromoErrorFromResponse(error)
  return promoError ? {...promoError, friendly: true} : null
}

export const sumPromoDiscount = (items?: {promoDiscount?: number | null}[] | null) =>
  (items || []).reduce((acc, item) => acc + Number(item.promoDiscount || 0), 0)
